export class HashHelper
{
    /**
     * Получаем все переменные со значениями их Хэша
     * @returns {
     *      {[p: string]: String}[]
     * }
     */
    static getVariables()
    {
        return window.location.hash
            .replace(/^#+/, '')
            // Иногда в hash могут появляться пустые сегменты из-за `&&` или хвостового `&`.
            // Они превращаются в ключ `''` и далее формируют параметр вида `&=...`.
            .split('&')
            .filter(Boolean)
            .reduce((params, hash) => {
                const [key, ...rest] = hash.split('=');
                if (!key) {
                    return params;
                }
                // декодируем значение уже ПОСЛЕ разбиения по `&`, а не всю строку целиком —
                // иначе закодированные `&`/`=` внутри значения (например, URL с query-параметрами)
                // после общего decode превращаются в "настоящие" и ошибочно режут параметры хэша
                const val = decodeURIComponent(rest.join('=')); // соединяем обратно всё, что после первого "="
                return Object.assign(params, { [key]: val });
            }, {});
    }

    /**
     * Получаем хэш из объекта
     * @param model {Object}
     * @returns {string}
     */
    static getHash(model) {
        let data = [];
        for (const [key, value] of Object.entries(model)) {
            data.push(key + '=' + value);
        }

        return data.join('&');
    }
}
